module.exports = __webpack_public_path__ + "assets/img/zccb.c13d8fdc.png";